import React from "react";
import classes from "./NotificationBell.module.css";
import { Skeleton } from "@mui/material";
import { Check } from "@mui/icons-material";

const NotificationCard = ({ notificationsData, isLoading, notificationClick }) => {
    const localCopy = Array.isArray(notificationsData) ? notificationsData : [];
    const hasRows = localCopy.length > 0;

    return (
        <div className={classes.notificationList}>
            {hasRows ? localCopy?.map((e, i) => {
                const message = String(e?.message || "").trim();
                const title = String(e?.title || "").trim();
                const hasDistinctTitle = Boolean(title) && title.toLowerCase() !== message.toLowerCase();

                return (
                    <div
                        className={`${classes.notificationCard} ${e?.status === false && classes.unread}`}
                        key={e?._rowKey || i}
                        onClick={() => {
                            e?.status === false && e?.id && notificationClick(e);
                        }}
                    >
                        {
                            !isLoading || hasRows ? <div className={classes.notificationCardBody}>
                                <div className={classes.notificationCardTopRow}>
                                    <span className={classes.notificationState}>
                                        {e?.status === false ? "Unread" : "Read"}
                                    </span>
                                    {e?.created ? (
                                        <span className={classes.createdDate}>{e?.created}</span>
                                    ) : null}
                                </div>
                                {hasDistinctTitle ? (
                                    <p className={classes.notificationTitle}>
                                        {title}
                                    </p>
                                ) : null}
                                <p className={classes.notificationMessage}>
                                    {message}
                                </p>
                                <div className={classes.notificationCardFooter}>
                                    <span className={classes.notificationMeta}>
                                        {e?.status === false ? "Tap to mark as read" : "Read"}
                                    </span>
                                    {e?.status === true && <Check className={classes.notificationReadIcon} />}
                                </div>
                            </div> :
                                <>
                                    <Skeleton height={"22px"} />
                                    <Skeleton height={"18px"} />
                                    <Skeleton height={"18px"} width={"72%"} />
                                </>
                        }
                    </div>
                );
            }) : isLoading ? (
                <>
                    {[0, 1, 2].map((item) => (
                        <div className={classes.notificationCard} key={item}>
                            <Skeleton height={"22px"} />
                            <Skeleton height={"18px"} />
                            <Skeleton height={"18px"} width={"72%"} />
                        </div>
                    ))}
                </>
            ) : <div className={classes.notificationError}>
                <p>No Notification found!</p>
            </div>}
        </div>
    );
};

export default NotificationCard;
